import { PayloadAction, createSlice } from '@reduxjs/toolkit';
///////////////////////////////////////////////////////////
import { User } from '@/core/interfaces';

const userSlice = createSlice({
	name: 'user',
	initialState: {
		data: {
			id: 0,
			firstName: '',
			lastName: '',
			username: '',
			isPremium: false,
			email: '',
			emailUpdated: false,
			pendingEarnAction: false,
			pendingBuildAction: false,
		} as User,
		updatedLang: '',
		visibleWarning: true,
		isAirdropUser: false,
		vtnAmount: 0,
	},
	reducers: {
		setUser: (state, action: PayloadAction<User>) => {
			state.data.id = action.payload.id;
			state.data.firstName = action.payload.firstName;
			state.data.lastName = action.payload.lastName;
			state.data.username = action.payload.username;
			state.data.photoUrl = action.payload.photoUrl;
			state.data.isPremium = action.payload.isPremium;
		},
		setEmail: (state, action: PayloadAction<{ email: string }>) => {
			state.data.email = action.payload.email;
		},
		setEmailUpdated: (state, action: PayloadAction<boolean>) => {
			state.data.emailUpdated = action.payload;
		},
		setPendingEarnAction: (state, action: PayloadAction<boolean>) => {
			state.data.pendingEarnAction = action.payload;
		},
		setPendingBuildAction: (state, action: PayloadAction<boolean>) => {
			state.data.pendingBuildAction = action.payload;
		},
		setUpdatedLang: (state, action: PayloadAction<string>) => {
			state.updatedLang = action.payload;
		},
		setVisibleWarning: (state, action: PayloadAction<boolean>) => {
			state.visibleWarning = action.payload;
		},
		setIsAirdropUser: (state, action: PayloadAction<boolean>) => {
			state.isAirdropUser = action.payload;
		},
		setVTNAmount: (state, action: PayloadAction<number>) => {
			state.vtnAmount = action.payload;
		},
	},
});

const { reducer, actions } = userSlice;

export const {
	setUser,
	setEmail,
	setEmailUpdated,
	setPendingEarnAction,
	setPendingBuildAction,
	setUpdatedLang,
	setVisibleWarning,
	setIsAirdropUser,
	setVTNAmount,
} = actions;
export default reducer;
